import { render, staticRenderFns } from "./page_sf.vue?vue&type=template&id=01456e54&"
import script from "./page_sf.vue?vue&type=script&lang=js&"
export * from "./page_sf.vue?vue&type=script&lang=js&"
import style0 from "./page_sf.vue?vue&type=style&index=0&id=01456e54&prod&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\nmgkjcx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports